import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {withStyles} from '@material-ui/core/styles';
import "./channelDashboard.css";
import Switch from '@material-ui/core/Switch';

import LearningCycle from "../../../components/dashboard_learningCycleView";
import channelData from "../../../modals/d_channels";
import {activateComponent, toggleLanguage} from "./redux_actions";
import {Link, Redirect} from "react-router-dom";

import PDFReader from "../../../components/MultiPagePDFReader";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  }
});

let channelDashboard = class channelDashboard extends Component {
  render() {
    const { channelState } = this.props;
    let channelId = this.props.match.params.channelId;
    let yearId = this.props.match.params.yearId;
    let channel = channelData[yearId] && channelData[yearId][channelId];
    if (!channel) {
      // Unknown or mistyped session link: back to the session list instead of a crash.
      return <Redirect to='/application/dashboard' />;
    }
    let activeStepId = channelState.activeComponents[channelId]
      ? channelState.activeComponents[channelId].milestone
      : Object.keys(channel.organisers.units)[0];
    let activeStep = activeStepId
      ? channel.organisers.units[activeStepId]?channel.organisers.units[activeStepId]:channel.organisers.units[Object.keys(channel.organisers.units)[0]]
      : channel.organisers.units[Object.keys(channel.organisers.units)[0]];
    let Layout = layout(activeStep.type, activeStep, this.props.channelState.hindi, channel.title);
    return (
      <div className="_dashboardCntr">
        <div style={{display:"flex", flexWrap:"wrap", justifyContent:"space-between"}}>
        <div
          style={{
          margin: "1rem",
          display: "flex",
          alignItems: "center",
          fontWeight: 600,
          fontSize: '1rem'
        }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
          <Link to='/application/dashboard'> My Sessions</Link>
        </div>
        <div className="language-toggle">
          <span aria-hidden="true">English</span>
          <Switch color="primary" checked={this.props.channelState.hindi}
            onChange={this.props.toggleLanguage} name="language" inputProps={{ 'aria-label': 'Show Hindi version' }}/>
          <span aria-hidden="true" lang="hi">हिन्दी</span>
        </div></div>

        <div className="programMapCntr">
          <div className="program-map-sidebar">
            <div
              style={{
              display: "flex",
              flexDirection: "column",
              height: "100%"
            }}>
              <div className="programOverviewTrigger">
              {/* <div className="ch-sub-title">{channel.heading}</div> */}
              <div className="ch-title">{channel.title}</div>
              </div>
              <div className="program-flow-cntr">
                <LearningCycle
                  stepperstate={{
                  activeStepId
                }}
                  referenceId={channelId}
                  className="steps"
                  elements={channel.organisers}
                  onclick={(el) => {
                  this
                    .props
                    .activateComponent(el);
                  // On narrow screens the slides sit below the step list, so bring them into view.
                  if (window.matchMedia && window.matchMedia("(max-width: 900px)").matches) {
                    setTimeout(() => {
                      const target = document.getElementById("step-details");
                      if (target) {
                        target.scrollIntoView({ behavior: "smooth", block: "start" });
                      }
                    }, 50);
                  }
                }}/>
              </div>
            </div>
          </div>
          <div className="program-map-main">
            <div className="step-details-cntr" id="step-details">
              {Layout}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function layout(type, data, hindi, channelTitle) {
  let src = hindi&&data.srcHn?data.srcHn:data.src;
  switch (type) {
    case 'ppt':
      // Sized by CSS (960:569 aspect ratio) so it follows window resizes and rotation.
      return <div className="ppt-frame-cntr">
        <iframe
          title={[channelTitle, data.title].filter(Boolean).join(" – ") || "Session slides"}
          src={src}
          frameBorder="0"
          allowFullScreen={true}></iframe>
      </div>
    case 'tool':
      let Tool = data.tool;
      return <Tool/>
    case 'pdf':
      return <div id='_book_meta_cntr' className='_book_meta_cntr'>
      <PDFReader src={src} docRatio={1.485}/>
    </div>
    default:
      return null
  }
}

const mapStateToProps = state => ({auth: state.auth, channelState: state.channelState});

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    activateComponent, toggleLanguage
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(withStyles(styles)(channelDashboard));